var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 70,
    viewBox: "0 0 115.537 145.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(5.75 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 48.403,
    cy: 48.403,
    r: 48.403,
    transform: "translate(0.005 48.755)",
    fill: "#f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M-219.792,5500.534h96.806s1.482-49.853-48.4-97.158C-221.274,5450.682-219.792,5500.534-219.792,5500.534Z",
    transform: "translate(219.797 -5403.376)",
    fill: "#f22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M-145.917,5591.791l-1.859-1.146a91.728,91.728,0,0,1-10.608-7.56,78.353,78.353,0,0,1-19.669-28.792l-.145-.364a46.156,46.156,0,0,0-1.823-6.478l-1.231-3.156-3.3.756a108.563,108.563,0,0,1-12.832,2.11,26.347,26.347,0,0,0-6.432-16.15c-6.878-7.981-16.584-16.778-28.847-26.148-9.056-6.92-16.061-11.5-16.355-11.687l-3.612-2.354-4.722-3.076-1.289,5.681-.754,4.245a24.037,24.037,0,0,0,.122,7.474,33.388,33.388,0,0,0,1.264,5.384,21.446,21.446,0,0,0-.453,2.465,16.457,16.457,0,0,0,1.181,8.8c-.009.152-.016.3-.022.458a38.024,38.024,0,0,0,.524,10.78,20.664,20.664,0,0,0,4.758,9.9,28.664,28.664,0,0,0,1.344,7.435,23.241,23.241,0,0,0,10,12.891,27.312,27.312,0,0,0,6.4,6.835,35.488,35.488,0,0,0,10.679,5.5q1.525.5,3.15.89a10.027,10.027,0,0,0-.483,3.4l.038,1.939,1.564,1.149a146.656,146.656,0,0,0,17.322,10.36c6.451,3.376,13.306,6.537,20.373,9.395a249.662,249.662,0,0,0,27.312,9.23l1.736.477,1.72-1.166a9.43,9.43,0,0,0,3.271-5.573l.165-.913a10.864,10.864,0,0,0,1.114-1.356,11.963,11.963,0,0,0,2.039-5.742h0a40.943,40.943,0,0,0,.194-4.359l0-.416Z",
    transform: "translate(259.625 -5472.969)",
    fill: "#f22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M12.69,5700.831a1.7,1.7,0,0,0,.068,2.37,36.731,36.731,0,0,1,4.768,7.272,24,24,0,0,0-1.449-9.49C14.8,5698.032,12.69,5700.831,12.69,5700.831Z",
    transform: "translate(35.357 -5647.744)",
    fill: "#f22c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M-182.222,5870.5a27.742,27.742,0,0,0,12.9,11s-12.368.068-18.192-6.792Z",
    transform: "translate(200.14 -5788.688)",
    fill: "#f22c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M203.541,5942.32a33.534,33.534,0,0,0,12,4.773l-5.232,3.351Z",
    transform: "translate(-122.421 -5847.928)",
    fill: "#f22c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M98.846,6066.648c-.017-.086-13.131-6.471-13.131-6.471a89.451,89.451,0,0,0,8.369,11.086Z",
    transform: "translate(-25.231 -5945.143)",
    fill: "#f22c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(3.926 21.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(38.687 54.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M5.748,5860.7l26.462-2.593s7.391,27.318,34.728,43.312c0,0,1.658,11.528-18.533,4.073S9.048,5888.1,4.63,5883.513,6,5874.605,5.748,5860.7Z",
    transform: "translate(0.415 -5854.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M12.6,5890.05s12.239,5.668,13.743,14.029a33.392,33.392,0,0,1-.467,14.607s-14.391-4.812-14.943-11.063S12.6,5890.05,12.6,5890.05Z",
    transform: "translate(-6.089 -5880.722)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M8.089,5909.343a5.87,5.87,0,0,1-.61-1.836c-.33-2.229.325-4.469.879-6.609a44.129,44.129,0,0,0,1.337-13.15c.872.475,1.771.907,2.624,1.415.226.134.454.269.682.4a50.331,50.331,0,0,1-.98,10.327c-1.159,5.528-1.956,8.077-.862,11.644A36.311,36.311,0,0,1,8.089,5909.343Z",
    transform: "translate(-3.237 -5878.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M17.55,5965.47c-.775,3.333,1.32,8.176,5.469,11.074l-8.171-4.137,2.359-8.681Z",
    transform: "translate(-9.389 -5941.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M120.824,5965.835s-8.691-.155-13.05,4.284-7.356,11.626-7.356,11.626l18.98,8.646a20.643,20.643,0,0,1,9.947-12.7Z",
    transform: "translate(-79.972 -5943.235)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M114.834,5968.04s-15.32-.135-19.8,15.5l-3.725-2.052s5.411-14.449,21.623-15.977Z",
    transform: "translate(-72.456 -5942.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M118.844,6048.351a172.561,172.561,0,0,1-19.141-9.482l-1.846,5.187,17.49,9.106Z",
    transform: "translate(-77.859 -6003.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M2.3,5865.45a70.227,70.227,0,0,0,12.176-.048,68.476,68.476,0,0,0,12.155-2.1A84.529,84.529,0,0,0,48.2,5894.834c3.963,3.62,11.719,8.4,11.719,8.4-.241,2.46-1.713,3.78-4.523,4.028-2.625.232-6.417-.472-11.463-2.055-10.449-3.28-23.188-10.281-30.56-13.623S.458,5885.727.394,5881.1c-.029-2.041,1.027-5.684,1.32-8.057a73.671,73.671,0,0,0,.59-7.595m-3.463-3.81-.036,3.779a71.554,71.554,0,0,1-.563,7.2c-.1.8-.319,1.864-.551,2.986a28.021,28.021,0,0,0-.794,5.548c.046,3.3,1.759,6.1,5.237,8.537a62.679,62.679,0,0,0,9.794,5.083c2.026.919,4.556,2.164,7.236,3.482,7.11,3.5,15.959,7.856,23.721,10.292,5.657,1.776,9.731,2.477,12.819,2.2,4.484-.4,7.289-3.011,7.7-7.173l.213-2.174-1.859-1.146c-.075-.046-7.524-4.651-11.195-8a82.307,82.307,0,0,1-20.671-30.242l-1.18-2.966-3.062.9a65.9,65.9,0,0,1-11.474,1.973,66.54,66.54,0,0,1-11.566.049l-3.765-.324Z",
    transform: "translate(5.421 -5855.146)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(6.62 8.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M35.981,5913.831l-1.772-.49c.01-.046.091-.418.287-1.023.626-2.5,1.93-9.663-1.586-16.167A23.085,23.085,0,0,0,21.476,5885.6l.6-1.742a24.629,24.629,0,0,1,12.458,11.421,22.88,22.88,0,0,1,2.576,11.756c.309-.458.649-.926,1.023-1.4,2.833-3.568,8.208-7.985,17.723-8.77L56,5898.7c-7.111.586-12.64,3.306-16.432,8.079a19.98,19.98,0,0,0-3.277,5.968C36.133,5913.376,36.006,5913.758,35.981,5913.831Z",
    transform: "translate(-21.476 -5883.855)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(38.884 33.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M207.5,6043.88l-1.809-.345a19.792,19.792,0,0,1,11.311-14.384l.678,1.711A18.281,18.281,0,0,0,207.5,6043.88Z",
    transform: "translate(-205.694 -6029.151)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M-12.4,5990.845a11.121,11.121,0,0,0-2.96.665,4.355,4.355,0,0,0-.964,3.29s23.608,17.338,63.724,28.364a5.561,5.561,0,0,0,1.821-3.173,20.376,20.376,0,0,0-2.875-3.062s-14.028.615-35.432-10.083S-12.4,5990.845-12.4,5990.845Z",
    transform: "translate(16.321 -5963.865)",
    fill: "#1a1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M325.047,6098.1a12.969,12.969,0,0,1-2.726-1.582,2.831,2.831,0,0,1-1.124-2.028,1.892,1.892,0,0,0,.2,2.569A5.667,5.667,0,0,0,325.047,6098.1Z",
    transform: "translate(-261.731 -6049.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M7.95,5846.347a54.541,54.541,0,0,1,.006-6.8,113.405,113.405,0,0,0,28.984-2.755,45.1,45.1,0,0,1,1.907,7.171l-16.594.907Z",
    transform: "translate(-3.609 -5836.795)",
    fill: "#1a1b1d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M29.656,5975.6l-.765.726a12.468,12.468,0,0,1-4.444,2l.1-2.815Z",
    transform: "translate(21.38 -5896.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M-176.782,5614.422a7.724,7.724,0,0,1-3.157-.711c-.77.026-1.536.041-2.283.041-12.222,0-19.575-3.669-23.591-6.748a20.6,20.6,0,0,1-5.763-6.528,17.888,17.888,0,0,1-8.8-10.6,22.751,22.751,0,0,1-1.08-8.1c-2.419-1.864-4.057-4.779-4.874-8.678a32.555,32.555,0,0,1-.418-9.354,12.254,12.254,0,0,1,.18-1.838c-2.522-3.875-1.186-8.733-.6-10.413a25.819,25.819,0,0,1-1.607-6.007,18.976,18.976,0,0,1-.141-5.719l.377-2.123,1.806,1.178c.281.183,28.27,18.513,44.069,36.846a20.934,20.934,0,0,1,5.148,14.2q0,.163-.011.327v.031c-.029.7-.048,1.327-.056,1.9-.057,3.756.282,5.574,1.45,7.775l.012.024a28.546,28.546,0,0,1,2.818,12.665l-.033.852-.765.374a6.042,6.042,0,0,1-2.68.608Z",
    transform: "translate(230.487 -5535.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M-234.234,5528.844s27.917,18.189,43.767,36.582a19.554,19.554,0,0,1,4.8,13.231q0,.166-.011.333h0c-.029.7-.048,1.341-.057,1.942-.061,4.024.348,6.075,1.616,8.465a27.294,27.294,0,0,1,2.665,11.965,4.638,4.638,0,0,1-2.053.463,6.3,6.3,0,0,1-2.845-.724q-1.334.054-2.595.054c-22.886,0-28.283-12.907-28.283-12.907-9.8-4.793-9.752-15.839-9.487-18,.024-.206.044-.322.044-.322-5.685-3.662-5.821-12.691-5.376-17.269a9.562,9.562,0,0,1,.282-2.231c-3.171-4.111-.588-10.137-.588-10.137a24.179,24.179,0,0,1-1.735-6.192,17.591,17.591,0,0,1-.146-5.25m-2.055-4.745-.754,4.246a20.19,20.19,0,0,0,.136,6.186,27.8,27.8,0,0,0,1.5,5.837,17.857,17.857,0,0,0-.672,3.1,12.091,12.091,0,0,0,1.3,7.565,13.94,13.94,0,0,0-.116,1.456,33.985,33.985,0,0,0,.447,9.732,15.942,15.942,0,0,0,4.816,9.038,24.753,24.753,0,0,0,1.177,7.889,19.293,19.293,0,0,0,9.1,11.216,22.411,22.411,0,0,0,5.949,6.607,31.592,31.592,0,0,0,9.5,4.885,48.5,48.5,0,0,0,14.956,2.157c.658,0,1.33-.011,2.006-.031a9.1,9.1,0,0,0,3.433.7,7.469,7.469,0,0,0,3.307-.753l1.53-.749.067-1.7a30.131,30.131,0,0,0-2.97-13.367l-.012-.024-.013-.023c-.917-1.729-1.343-3.228-1.284-7.085.009-.562.026-1.167.055-1.85l0-.058v-.021c0-.106.008-.213.01-.318a22.355,22.355,0,0,0-5.493-15.165c-6.7-7.777-16.209-16.388-28.257-25.592-8.943-6.834-15.826-11.329-16.115-11.518l-3.612-2.354Z",
    transform: "translate(237.21 -5524.1)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(2.42 19.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(8.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M-133.678,5684.986a6.4,6.4,0,0,1-2.23-1.927c-1.07-1.369-2.416-3.916-2.758-8.279l-.009-.112c-.356-4.549-.591-7.555-2.493-10.866-1.84-3.2-5.221-6.633-12.059-12.233-3.293-2.7-6.2-5.011-8.707-6.968a100.742,100.742,0,0,0-10.2-6.853,61.542,61.542,0,0,0,7.349,6.8l0,0c2.873,2.212,6.369,4.975,10.476,8.338,13.052,10.69,13.238,13.066,13.93,21.909l.009.112a23.408,23.408,0,0,0,.5,3.358C-138.049,5684.924-133.678,5684.986-133.678,5684.986Z",
    transform: "translate(172.138 -5637.748)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(0 3.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M-221.871,5656.786l-1.524.373c.586,2.395,2.653,5.041,5.181,7.525a27.359,27.359,0,0,0,10.049,6.114C-216.035,5665.327-221.031,5660.221-221.871,5656.786Z",
    transform: "translate(223.395 -5656.786)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(1.166 20.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M-215.286,5752.492l-1.449.6c.945,2.277,3.392,4.576,6.27,6.645a27.359,27.359,0,0,0,10.865,4.508C-208.214,5760.041-213.932,5755.757-215.286,5752.492Z",
    transform: "translate(216.735 -5752.492)",
    fill: "#1a1b1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(12.683 41.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M-150.421,5876.1q-.271.76-.56,1.51c.88.584,1.833,1.14,2.829,1.668a27.362,27.362,0,0,0,11.377,2.99A56.568,56.568,0,0,1-150.421,5876.1Z",
    transform: "translate(150.981 -5876.103)",
    fill: "#1a1b1d"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0ad8bf823aa7ea7f5a9aae149c7bd63.svg";
export { ForwardRef as ReactComponent };